<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	{height}
	{width}
	class={className}
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M19.2576 17.5603L23.6486 21.9504C24.1173 22.4191 24.1173 23.179 23.6486 23.6477C23.1799 24.1164 22.42 24.1164 21.9514 23.6477L17.5603 19.2566C17.3936 19.0904 17.1309 19.0697 16.9402 19.2077C12.6757 22.2894 6.75923 21.5777 3.34734 17.5725C-0.0645569 13.5674 0.173193 7.61296 3.89355 3.8926C7.61391 0.172239 13.5683 -0.0655106 17.5735 3.34638C21.5786 6.75828 22.2903 12.6748 19.2086 16.9392C19.0701 17.1301 19.0909 17.3934 19.2576 17.5603ZM2.88 11.04C2.88 15.5466 6.53335 19.2 11.04 19.2C15.5444 19.1947 19.1947 15.5445 19.2 11.04C19.2 6.53336 15.5466 2.88 11.04 2.88C6.53335 2.88 2.88 6.53336 2.88 11.04Z"
		fill="currentColor"
	/>
	<path
		d="M16.125 9.77467C16.125 10.5188 15.8466 11.2157 15.3403 11.7397L11.3662 15.8533C11.346 15.8742 11.2903 15.9214 11.265 15.9371C11.2043 15.979 11.1334 16 11.0625 16C10.9916 16 10.9157 15.979 10.8549 15.9371C10.8246 15.9162 10.7992 15.8952 10.7689 15.8638L6.78975 11.7397C6.27844 11.2157 6 10.5188 6 9.77467C6 9.03057 6.27844 8.33363 6.78975 7.80961C7.83769 6.73013 9.53869 6.73013 10.5866 7.80961L11.0625 8.30742L11.5434 7.80961C12.5914 6.73013 14.2924 6.73013 15.3353 7.80961C15.8466 8.33363 16.125 9.03057 16.125 9.77467Z"
		fill="currentColor"
	/>
</svg>
